import { name } from "file-loader";

export const organizationData = [
    {
        "index": 1,
        "name": "John Prior",
        "Organization": "Hospital and University of Lausanne",
        "location": "Lausanne, Switzerland",
        "website": "https://imagingcommission.org"
    },
    {
        "index": 2,
        "name": "Horacio Amaral",
        "Organization": "PositronMed",
        "location": "Santiago de Chile，Chile"
    },
    {
        "index": 3,
        "name": "Jose Maria Benlloch",
        "Organization": "i3M (CSIC-UPV)",
        "location": "Valencia, Spain"
    },
    {
        "index": 4,
        "name": "Thomas Beyer",
        "Organization": "QIMP Team, Medical University Vienna",
        "location": "Vienna, Austria"
    },
    {
        "index": 5,
        "name": "Julie Brefczynski",
        "Organization": "Rockefeller Neuroscience Institute",
        "location": "West Virginia, USA"
    },
    {
        "index": 6,
        "name": "Simon Cherry",
        "Organization": "University of California, Davis",
        "location": "Davis, California, USA"
    },
    {
        "index": 7,
        "name": "Junwei Du",
        "Organization": "University of California, Davis",
        "location": "Davis, California, USA"
    },
    {
        "index": 8,
        "name": "Georges El Fakhri",
        "Organization": "Yale University",
        "location": "New Haven, Connecticut, USA"
    },
    {
        "index": 9,
        "name": "Karol Lang",
        "Organization": "University of Texas in Austin",
        "location": "Austin, Texas, USA"
    },
    {
        "index": 10,
        "name": "Roger Lecomte",
        "Organization": "Sherbrooke Molecular Imaging Center",
        "location": "Sherbrooke, Quebec, Canada"
    },
    {
        "index": 11,
        "name": "Paul Lecoq",
        "Organization": "European Organization for Nuclear Research",
        "location": "Valencia, Spain and Geneva, Switzerland"
    },
    {
        "index": 12,
        "name": "Jae Sung Lee",
        "Organization": "Korea Institute of Science and Technology",
        "location": "Seoul, South Korea"
    },
    {
        "index": 13,
        "name": "Craig Levin",
        "Organization": "Rad/Molecular Imaging Program at Stanford",
        "location": "Stanford, California, USA"
    },
    {
        "index": 14,
        "name": "Gabriela Llosa",
        "Organization": "IFIC (CSIC-UVEG)",
        "location": "Valencia, Spain"
    },
    {
        "index": 15,
        "name": "Stan Majewski",
        "Organization": "University of California Davis",
        "location": "Davis, California, USA"
    },
    {
        "index": 16,
        "name": "Paweł Moskal",
        "Organization": "Jagiellonian University",
        "location": "Cracow, Poland"
    },
    {
        "index": 17,
        "name": "Sadek Nehmeh",
        "Organization": "Weill Cornell Medical College",
        "location": "Ithaca, New York, USA"
    },
    {
        "index": 18,
        "name": "Qiyu Peng",
        "Organization": "Shenzhen Bay Laboratory",
        "location": "Shenzhen, Guangdong, China"
    },
    {
        "index": 19,
        "name": "Rok Pestotnik",
        "Organization": "Jožef Stefan Institute",
        "location": "Ljubljana, Slovenia"
    },
    {
        "index": 20,
        "name": "Hamid Sabet",
        "Organization": "Massachusetts General Hospital",
        "location": "Boston, Massachusetts, USA"
    },
    {
        "index": 21,
        "name": "Volkmar Schulz",
        "Organization": "RWTH University Aachen",
        "location": "Aachen, Germany"
    },
    {
        "index": 22,
        "name": "Youngho Seo",
        "Organization": "University of California, San Francisco",
        "location": "San Francisco, USA"
    },
    {
        "index": 23,
        "name": "Ewa Stępień",
        "Organization": "Jagiellonian University",
        "location": "Cracow, Poland"
    },
    {
        "index": 24,
        "name": "Charalampos Tsoumpas",
        "Organization": "University of Groningen",
        "location": "Groningen, Netherlands"
    },
    {
        "index": 25,
        "name": "Stefaan Vandenberghe",
        "Organization": "Ghent University",
        "location": "Ghent, Belgium"
    },
    {
        "index": 26,
        "name": "Siwei Xie",
        "Organization": "Shenzhen Bay Laboratory",
        "location": "Shenzhen, Guangdong, China"
    },
    {
        "index": 27,
        "name": "Taiga Yamaya",
        "Organization": "National Institute of Radiological Sciences",
        "location": "Chiba, Japan"
    }
]



// WEBPACK FOOTER //
// ./src/assets/data/organizationData.js